export enum QueryKeys {
  API_DOCS = 'API_DOCS',
  CREATE_MEETING_BOT = 'CREATE_MEETING_BOT',
  USER = 'USER',
  WEB_APP_MEETINGS = 'WEB_APP_MEETINGS',
  WEB_APP_MEETING = 'WEB_APP_MEETING',
  GET_ACTIVE_MEETING_BOT = 'GET_ACTIVE_MEETING_BOT',
  GET_ANALYSIS_MEDIA = 'GET_ANALYSIS_MEDIA',
  GET_ANALYSIS_MEDIA_TIMELINE = 'GET_ANALYSIS_MEDIA_TIMELINE',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  BOT_CONFIG = 'BOT_CONFIG',
  CONSENT_CONFIG = 'CONSENT_CONFIG',
  GET_MEETING_URL = 'GET_MEETING_URL',
  GET_USER_PREFERENCES = 'GET_USER_PREFERENCES',
  BOT_REPORT = 'BOT_REPORT',
  VOICEBIO_ENROLLMENTS = 'VOICEBIO_ENROLLMENTS',
  RULES = 'RULES',
  ADMIN_USERS = 'ADMIN_USERS',
  TEAMS_APP_AUTH_TENANTS = 'TEAMS_APP_AUTH_TENANTS',
  CHECK_CONSENT_REQUIRED = 'CHECK_CONSENT_REQUIRED',
  CONSENT_REQUIRED_SEALED = 'CONSENT_REQUIRED_SEALED',
  AUDIT_LOGS = 'AUDIT_LOGS',
  AUDIT_FILTER_OPTIONS = 'AUDIT_FILTER_OPTIONS',
  ZOOM_CONNECTION_STATUS = 'ZOOM_CONNECTION_STATUS',
  MS_TEAMS_BOT_CONFIG = 'MS_TEAMS_BOT_CONFIG',
}
